import React from 'react';
import { screenGte, useMediaQuery } from 'modules/media/use-media-query';
import { useUserState } from 'modules/user/UserContext';
import { Intro } from 'modules/intro';
import { dexIntoJs } from '../../../research/intro';
import createPersistedState from 'use-persisted-state';

const useIntroPersistedState = createPersistedState<boolean>('mizar-dex-intro');

export function IntroBlocker({ children }: { children: React.ReactNode }) {
  const isDesktop = useMediaQuery(screenGte.small);
  const { user } = useUserState();
  const searchParams = new URLSearchParams(location?.search);
  const isAuthPage = searchParams.has('auth');
  const [skipMizarInto, setMizarIntro] = useIntroPersistedState(false);

  const handleSkipIntro = () => {
    setMizarIntro(true);
  };

  if (!skipMizarInto && isDesktop && user && 'id' in user && !isAuthPage) {
    return <Intro steps={dexIntoJs} onSkipIntro={handleSkipIntro} />;
  }

  return <>{children}</>;
}
